import React, { useEffect, useState } from 'react';
import '../styles/toast.css';

const Toast = ({ message, type = 'info', duration = 4000, onClose }) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsExiting(true);
            setTimeout(onClose, 300); // Match CSS fade-out duration
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`toast toast-${type} ${isExiting ? 'toast-exit' : ''}`}>
            <div className="toast-content">
                {type === 'success' && <span className="toast-icon">✓</span>}
                {type === 'error' && <span className="toast-icon">✕</span>}
                {type === 'warning' && <span className="toast-icon">⚠</span>}
                {type === 'info' && <span className="toast-icon">ℹ</span>}
                <span className="toast-message">{message}</span>
            </div>
            <div className="toast-progress"></div>
        </div>
    );
};

export default Toast;
